<template>
  <div class="schedule-making">
    <div class="dateser">
      <span>查询日期： </span>
      <el-date-picker
          v-model="value2"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"/>
    </div>
    <div><span class="heading">目前排产状况表</span></div>
    <el-table
        :data="tableCol"
        border
        style="width: 100%">
      <el-table-column fixed type="index" width="80" label="产线名称"/>
      <el-table-column
          show-overflow-tooltip
          label="value1"
          width="100px">
        <template slot-scope="scope">
          <div class="blueint">{{scope.row.value1}}</div>
          <div style="margin: 2px 0;"/>
          <el-input v-model="scope.row.value1" class="redint" placeholder="0"/>
        </template>
      </el-table-column>
      <el-table-column
          show-overflow-tooltip
          label="value2"
          width="100px">
        <template slot-scope="scope">
          <div class="blueint">{{scope.row.value2}}</div>
          <div style="margin: 2px 0;"/>
          <el-input v-model="scope.row.value2" class="redint" placeholder="0"/>
        </template>
      </el-table-column>
    </el-table>

    <div><span class="heading">目前排产状况表</span></div>


    <el-form :inline="true" :model="searchline" class="demo-form-inline">
      <el-form-item label="销售订单">
        <el-input v-model="searchline.srh1" width="140" placeholder="销售订单"/>
      </el-form-item>
      <el-form-item label="生产订单">
        <el-input v-model="searchline.srh2" width="140" placeholder="生产订单"/>
      </el-form-item>
      <el-form-item label="出厂编号">
        <el-input v-model="searchline.srh3" width="140" placeholder="出厂编号"/>
      </el-form-item>
      <el-form-item label="原交货日期">
        <el-input v-model="searchline.srh4" width="140" placeholder="原交货日期"/>
      </el-form-item>
      <el-form-item label="最终交货日期">
        <el-input v-model="searchline.srh5" width="140" placeholder="最终交货日期"/>
      </el-form-item>
      <el-form-item label="原生产开始">
        <el-input v-model="searchline.srh6" width="140" placeholder="原生产开始"/>
      </el-form-item>
      <el-form-item label="原生产结束">
        <el-input v-model="searchline.srh7" width="140" placeholder="原生产结束"/>
      </el-form-item>
      <el-form-item label="客户名称">
        <el-input v-model="searchline.srh8" width="140" placeholder="客户名称"/>
      </el-form-item>
      <el-form-item label="物料描述">
        <el-input v-model="searchline.srh9" width="140" placeholder="物料描述"/>
      </el-form-item>
      <el-form-item label="订单类别">
        <el-input v-model="searchline.srh10" width="140" placeholder="订单类别"/>
      </el-form-item>
      <el-form-item label="数量">
        <el-input v-model="searchline.srh11" placeholder="数量"/>
      </el-form-item>
      <el-form-item label="开工日期">
        <template>
          <el-date-picker
              v-model="value1"
              type="date"
              placeholder="选择日期"/>
        </template>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
        :data="tableData"
        border
        style="width: 100%">
      <el-table-column fixed prop="salesID" width="120" label="销售订单"/>
      <el-table-column fixed prop="productID" width="100" label="生产订单"/>
      <el-table-column prop="outNo" width="100" label="出厂编号"/>
      <el-table-column prop="odDate" width="85" label="原交货日期"/>
      <el-table-column prop="fdDate" width="85" label="最终交货日"/>
      <el-table-column prop="oproDate" width="85" label="原生产开始"/>
      <el-table-column prop="fproDate" width="85" label="原生产结束"/>
      <el-table-column prop="cusName" label="客户名称"/>
      <el-table-column prop="maDescribe" label="物料描述"/>
      <el-table-column prop="ordType" width="70" label="订单类别"/>
      <el-table-column prop="ordNum" width="50" label="数量"/>
      <el-table-column prop="consumeTime" width="110" label="需消耗时间(分)"/>
      <el-table-column prop="returnTime" width="70" label="还原耗时">
        <template>
          <el-button type="primary" @click="onSubmit">还原</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="pChoice" width="70" label="请选择">
        <template>
          <el-radio v-model="radio"/>
        </template>
      </el-table-column>
      <el-table-column prop="startTime" width="130" label="开工日期">
        <template>
          <el-date-picker
              v-model="value1"
              type="date"
              size="mini"
              placeholder="选择日期"/>
        </template>
      </el-table-column>
      <el-table-column prop="finishTime" width="130" label="完工日期">
        <template>
          <el-date-picker
              v-model="value1"
              type="date"
              placeholder="选择日期"/>
        </template>
      </el-table-column>
      <el-table-column prop="save" width="50" label="保存">
        <el-checkbox/>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>



  export default {
    name: "ProductionDaily",
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          }],
        },
        searchline: {
          srh1: "",
          srh2: "",
          srh3: "",
          srh4: "",
          srh5: "",
          srh6: "",
          srh7: "",
          srh8: "",
          srh9: "",
          srh10: "",
          srh11: "",
          srh12: "",

        },
        value1: "",
        value2: "",
        tableData: [{
          salesID: "3100617957",
          productID: "1564518124",
          outNo: "PC1215445",
          odDate: "2019-07-17",
          fdDate: "2019-07-17",
          oproDate: "2019-07-17",
          fproDate: "2019-07-17",
          cusName: "谊新（上海）国际贸易有限公司",
          maDescribe: "波力国际AS380S控制柜汇总",
          ordType: "控制柜",
          ordNum: "100",
          consumeTime: "20",
          pChoice: "",
          startTime: "",
          finishTime: "",
        }],
        tableCol:[
          {
            value1: "",
            value2: "",
          },
          {
            value1: "",
            value2: "",
          },
        ],
        tableColin:[{
          dataItem: "shijian",
          dataName: "019/08/08",
        },{
          dataItem: "shijian",
          dataName: "2019/08/09",
        },{
          dataItem: "shijian",
          dataName: "2019/08/10",
        },{
          dataItem: "shijian",
          dataName: "2019/08/11",
        },{
          dataItem: "shijian",
          dataName: "2019/08/12",
        },{
          dataItem: "shijian",
          dataName: "2019/08/13",
        },{
          dataItem: "shijian",
          dataName: "2019/08/14",
        },{
          dataItem: "shijian",
          dataName: "2019/08/15",
        },{
          dataItem: "shijian",
          dataName: "2019/08/16",
        },{
          dataItem: "shijian",
          dataName: "2019/08/17",
        }],
        inputNum1:"",

      };
    },
  };
</script>

<style lang="scss" scoped>
</style>
